import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import {
  ICON_DEFAULTS,
  ICON_KEY_MAP,
  ICON_SIZE_CLASS_MAP,
  ICON_COLOR_CLASS_MAP,
  TIconProps,
} from "@/ui/components/primitives/Icon";

export const Icon: FC<TIconProps> = (
  {
    size = ICON_DEFAULTS.size,
    color = ICON_DEFAULTS.color,
    icon,
    className,
    ...props
  },
) => {
  const IconElement = ICON_KEY_MAP[icon];

  return (
    <div
      {...props}
      data-component="Icon"
      className={cn(
        "inline-flex items-center justify-center",
        "aspect-square",
        ICON_COLOR_CLASS_MAP[color],
        ICON_SIZE_CLASS_MAP[size],
        className,
      )}
    >
      <IconElement aria-hidden="true" className="h-full w-full" />
    </div>
  );
};

Icon.displayName = "Icon";
